import React from 'react';

export default function StarRating({ averageRating }) {
  const starRow = () => {
    let stars = [];
    for (let i = 0; i < averageRating; i++) {
      stars.push(<div key={i}>⭐</div>);
    }
    return stars;
  };

  return <div className='row'>{starRow()}</div>;
}
